<script setup lang="ts">
import CustomButton from "@/components/Button/Button.vue";
import CustomModal from "@/components/CustomModal/CustomModal.vue";
import {PropType, watch} from "vue";
import { Trip } from "@/models/Trip";
import { useI18n } from "vue-i18n";
import {VueSpinner} from "vue3-spinners";

const props = defineProps({
  showDeleteModal: Boolean,
  trip: Object as PropType<Trip>,
  isDeleting: {
    type: Boolean,
    default: false
  }
});

defineEmits<{
  'on-close': [void]
  'on-delete-click': [string]
}>();

const { t } = useI18n();

// Body scroll lock if popup displayed
watch(() => props.showDeleteModal, (newValue) => {
  if (newValue) {
    document.documentElement.style.overflow = 'hidden';
  } else {
    document.documentElement.style.overflow = 'auto';
  }
});

</script>

<template>
  <CustomModal :show="showDeleteModal" @close="$emit('on-close')" classes="w-1/6" :mobile-fullscreen="false" :custom-index="9999" extra-classes="h-fit" drawerHeight="fit-content">
    <div class="py-5 sm:p-5 flex flex-col modalDelete sm:max-w-sm sm:w-full">
      <div class="cursor-pointer self-end hidden sm:block" type="default" @click="$emit('on-close')">
        <img src="@/assets/icons/svg/Close_16x16.svg" alt="Close" width="18"/>
      </div>
      <div class="p-3.5 flex flex-col gap-8">
        <div class="responsive-title-4 font-semibold">{{ t('tripDeleteModal.deleteTrip') }}</div>
        <p>
          {{ t('tripDeleteModal.confirmationMessage') }}
        </p>
        <div class="flex gap-4 justify-space-between">
          <CustomButton
              type="black"
              class="self-start responsive-body-medium h-13"
              :outlined="false"
              :rounded="true"
              @click="$emit('on-delete-click', trip.uuid)"
          >
              <span class="flex items-center gap-2">
                <VueSpinner v-if="isDeleting" :size="16" color="white" />
                <span>{{ t('tripDeleteModal.deleteButton') }}</span>
              </span>
          </CustomButton>
          <CustomButton
              :outlined="true"
              class="self-start h-13 hover:bg-black hover:text-white hover:border-black transition-all"
              :rounded="true"
              @click="$emit('on-close')">
            {{ t('tripDeleteModal.cancelButton') }}
          </CustomButton>
        </div>
      </div>
    </div>
  </CustomModal>
</template>

<style scoped>

</style>
